import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from './AxiosConfig';
import date from 'date-and-time'; // Moved import to top
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

//===============================================================
function ReviewGoalMG(props) {
  const [progress,       setProgress]         = useState([]);
  const [progressLoaded, setProgressLoaded]   = useState(false);
  const [sgLoaded,       setSGLoaded]         = useState(false);
  const [subGoalItems,   setSubGoalItems]     = useState( [] );
  const colorsList = [
    {r: 30 , g: 30,  b: 30 },     // 0 - Not defined
    {r: 255, g: 0,   b: 0  },    // 1 - RAG_RED
    {r: 255, g: 255, b: 0 },     // 2 - RAG_YELLOW
    {r: 0,   g: 255, b: 0 },     // 3 - RAG_GREEN
    {r: 0,   g: 127, b: 255 },
    {r: 0,   g: 255, b: 127 },
    {r: 255, g: 127, b: 127 },
    {r: 127, g: 127, b: 255 },
    {r: 127, g: 255, b: 127 },
  ];

  useEffect(() => {
      async function getSubGoalItems() {
          if ( props?.goal?.id && !sgLoaded ) {
              try {
                  const response = await api.get(`/site/goals/allocated-to/${encodeURIComponent(props.goal.id)}`, {withCredentials: true });
                  setSubGoalItems(response.data);
                  setSGLoaded(true);
              } catch (error) {
                  console.log("getSubGoalItems: " + error);
              }
          }
      }
      // Fetch the progress record for this goal.
      getSubGoalItems();
  }, [sgLoaded, props.goal?.id]); 

  // Format date for date form control.
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

// Generate the Radar Plot
// Register the required components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

var theLabels = [];  
let summary = [];
var theData = [];
for ( let i = 0; i < subGoalItems.length ; i++) {
   theLabels.push(subGoalItems[i].goal_title);
   theData.push(subGoalItems[i].rag_score);
   console.log( "Data - " + subGoalItems[i].goal_title + ": " + subGoalItems[i].rag_score);
   let summaryLine = subGoalItems[i].goal_title; 
   if (subGoalItems[i].goal_description !== null) {
       summaryLine = summaryLine + ": " + subGoalItems[i].goal_description;
   }
   summary.push(  summaryLine );
}
  
var colorIndex = 0;
if ( props?.goal?.rag_status ) {
    colorIndex = props.goal.rag_status;
}
console.log("colorIndex=" + colorIndex );
const rgbString  = "rgb(" + colorsList[colorIndex].r + "," +  colorsList[colorIndex].g + "," + colorsList[colorIndex].b + ")";
const rgbaString = "rgb(" + colorsList[colorIndex].r + "," +  colorsList[colorIndex].g + "," + colorsList[colorIndex].b + ",0.2)";

var theDataSets = [];
var theDataSet = {
            label: "Latest Score",
            data: theData,
            backgroundColor: rgbaString,
            borderColor: rgbaString,
            pointBackgroundColor: rgbString,
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: rgbString,
}
theDataSets.push(theDataSet);
  
console.log("theLabels = " + JSON.stringify(theLabels));
const data = {
  labels: theLabels,
  datasets: theDataSets
};
        
const options = {
  responsive: true,
  scales: {
    r: {
      beginAtZero: true,
      max: 1,
      ticks: {
        stepSize: 20,
      },
    },
  },
};

return (
    <div>
      {sgLoaded ? (
        <>
          <div style={{ maxWidth: 600, margin: '0 auto' }}>
             <div className="dqt-summary">{summary.map ((item) => ( <div>{item}</div> ))}</div>
             <Radar data={data} options={options} />
          </div>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ReviewGoalMG;
